module.exports = __webpack_public_path__ + "static/ceforma-f9c5d3c6fe3ea2cbf9215ac345e38c8f.png";